import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { ButtonIcon } from 'components/button';
import { Dropdown, DropdownItem } from 'components/dropdown';
import { I18n } from 'components/translate';
import { sendEventCommentClassStatus } from 'modules/app/services/datahubEvents/moderationSupport/tryCommentClassStatus/utils';
import { COMMENT_STATUS_ENUM } from 'modules/community/constants';
import PropTypes from 'prop-types';

import './CommentsActionsDropdown.scss';

const label = {
  approve: 'general.approve',
  disapprove: 'general.disapprove',
  spam: 'general.spam'
};

export default class CommentsActionsDropdown extends PureComponent {
  static propTypes = {
    item: PropTypes.object,
    commentUserClass: PropTypes.string,
    commentStatusUpdate: PropTypes.func,
    className: PropTypes.string
  };

  createAction = (id, icon, label, status) => ({ id, icon, label, status });

  get actionsList() {
    return [
      this.createAction(
        'approve',
        'check-normal',
        label.approve,
        COMMENT_STATUS_ENUM.APPROVED
      ),
      this.createAction(
        'disapprove',
        'close',
        label.disapprove,
        COMMENT_STATUS_ENUM.DISAPPROVED
      ),
      this.createAction(
        'spam',
        'exclamation',
        label.spam,
        COMMENT_STATUS_ENUM.SPAM_CONFIRMED
      )
    ];
  }

  render() {
    const { className, commentUserClass, item, commentStatusUpdate } =
      this.props;

    const handleUpdateStatus = async (item, status) => {
      try {
        await commentStatusUpdate(item, status);

        sendEventCommentClassStatus({
          status,
          comment: item
        });
      } catch (error) {
        sendEventCommentClassStatus({
          isSuccess: false,
          status,
          failureDescription: error,
          comment: item
        });
      }
    };

    return (
      <Dropdown
        className={classNames('user__actions__dropdown', className)}
        classNameMenu={`user__actions__dropdown__menu ${commentUserClass}__dropdown__menu`}
        classNameToggle="user__actions__dropdown__toggle"
      >
        {this.actionsList.map((action) => (
          <DropdownItem
            key={action.id}
            onClick={() => handleUpdateStatus(item, action.status)}
          >
            <ButtonIcon
              className={`${commentUserClass}__text__description__dropdown`}
              id={action.id}
              icon={action.icon}
              size="small"
              transparent
            >
              <I18n label={action.label} />
            </ButtonIcon>
          </DropdownItem>
        ))}
      </Dropdown>
    );
  }
}
